import React from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

const ReturnsPolicy: React.FC = () => (
  <div className="legal-page">
    <div className="container">
      <h1>Returns &amp; Refunds</h1>
      <p className="legal-updated">Last updated: August 26, 2026</p>

      <p>
        We want you to love what you receive. Because many items are made to
        order, we handle returns a little differently than a typical store.
      </p>

      <h2>When you can return an item</h2>
      <ul>
        <li>The print arrived damaged, defective, or different from what you ordered</li>
        <li>You request the return within <strong>30 days of delivery</strong></li>
      </ul>
      <p>
        Custom photo prints and artist reproductions that arrived as ordered
        generally cannot be returned, because they are produced specifically
        for you. If something looks wrong, still open a return — we will make
        it right when the issue is on us.
      </p>

      <h2>How to start a return</h2>
      <ol>
        <li>Sign in and open <Link to="/history">Purchase History</Link>.</li>
        <li>Find the delivered order and choose <strong>Request Return</strong> on the item.</li>
        <li>Tell us what happened. We will email you with an RMA number and next steps.</li>
      </ol>
      <p>
        Guest orders are linked to your account if you later register with the
        same email. You can also email{' '}
        <a href="mailto:support@phiprinting.com">support@phiprinting.com</a>{' '}
        with your order number.
      </p>

      <h2>Refunds</h2>
      <p>
        Approved returns are refunded to the original payment method (Square or
        PayPal) after we receive the item, or immediately if we ask you not to
        ship it back. Shipping is refunded when the return is due to damage or
        our error.
      </p>
      <p>
        Track every request from <Link to="/returns">My Returns</Link>. Statuses
        move from Pending to Approved, Received, then Refunded.
      </p>

      <h2>Gifts</h2>
      <p>
        If the order was marked as a gift, the recipient should contact the
        purchaser, or reach us with the order number. We can still replace a
        damaged gift.
      </p>
    </div>
  </div>
);

export default ReturnsPolicy;
